import Token from '@/utils/Token';

export default {
    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/estado/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/estado/list${params}`, Token.getHeader());
    },
    option(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/estado/option${params}`, Token.getHeader());
    },

    create(params) {
        return axios.post(`/api/estado`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/estado/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/estado/${id}`, Token.getHeader());
    },
}